<div class="cgv-container">
  <h1>Conditions Générales de Vente – Service Qaryos (SaaS)</h1>
  <p class="last-updated">Dernière mise à jour : 20 mai 2025</p>

  <nav class="cgv-toc">
    <h2>Sommaire</h2>
    <ul>
      <li>1. Objet du contrat</li>
      <li>2. Durée du contrat</li>
      <li>3. Création de compte Client</li>
      <li>4. Description des offres et tarifs</li>
      <li>5. Modalités de commande et de paiement</li>
      <li>6. Droit de rétractation</li>
      <li>7. Résiliation de l’abonnement</li>
      <li>8. Responsabilité et garanties</li>
      <li>9. Cas de force majeure</li>
      <li>10. Propriété intellectuelle</li>
      <li>11. Droit applicable et juridiction</li>
    </ul>
  </nav>

  <section id="objet">
    <h2>1. Objet du contrat</h2>
    <p>
      Les présentes Conditions Générales de Vente (« CGV ») ont pour objet de définir les modalités
      contractuelles, commerciales et financières selon lesquelles la société Qaryos (ci-après « la
      Société » ou « le Prestataire ») fournit aux Clients professionnels (ci-après « le Client »)
      son service en ligne de gestion des rondes de sécurité Qaryos (ci-après « le Service »). Ces
      CGV complètent les Conditions Générales d’Utilisation (CGU) déjà en vigueur pour l’usage du
      Service. En souscrivant un abonnement au Service, le Client accepte sans réserve les présentes
      CGV ainsi que les CGU du site Qaryos. À noter : Le Service Qaryos est strictement réservé à
      une clientèle professionnelle. Le Client certifie agir dans le cadre de son activité
      professionnelle et reconnaît ne pas être un consommateur au sens du Code de la consommation.
      Le Client déclare également disposer du pouvoir et de l’autorité nécessaires pour engager la
      personne morale au nom de laquelle il souscrit le Service.
    </p>
  </section>

  <section id="duree">
    <h2>2. Durée du contrat</h2>
    <p>
      Le contrat d’abonnement au Service Qaryos entre en vigueur à la date de confirmation de la
      commande par la Société (ou à la date de signature du contrat d’abonnement le cas échéant) et
      est conclu pour la durée de l’abonnement choisie par le Client. Sauf mention contraire dans
      l’offre souscrite, les abonnements sont à durée indéterminée avec paiements périodiques
      (mensuels ou annuels). Chaque abonnement se renouvelle ensuite par tacite reconduction pour
      une durée équivalente (par exemple, de mois en mois ou d’année en année), sauf résiliation
      effectuée selon les modalités prévues aux présentes CGV. Si l’offre prévoit une durée minimale
      d’engagement (par exemple 12 mois pour une formule annuelle), le Client s’engage à respecter
      cette durée initiale. À l’issue de la période initiale, le contrat se prolongera par périodes
      successives identiques, sauf résiliation par l’une des Parties dans les conditions fixées
      ci-après.
    </p>
  </section>

  <section id="compte">
    <h2>3. Création de compte Client</h2>
    <p>
      L’accès au Service Qaryos nécessite la création d’un compte Client sur le site web ou
      l’application mobile. Le représentant du Client (tel qu’un responsable de sécurité ou
      gestionnaire désigné) doit créer un compte Administrateur en fournissant des informations
      exactes, à jour et complètes (raison sociale, coordonnées, adresse email professionnelle,
      etc.). Ce compte Administrateur permettra de gérer l’abonnement, les paramètres du Service
      (sites, rondes, etc.) et les comptes des agents de sécurité (« rondiers ») utilisant
      l’application mobile.
    </p>
    <p>
      Lors de la création du compte, le Client choisit un identifiant et un mot de passe
      confidentiel. Il appartient au Client de préserver la confidentialité de ces accès. Toute
      activité réalisée via le compte Administrateur ou les comptes utilisateurs associés sera
      réputée effectuée par le Client. En cas d’utilisation non autorisée du compte ou de violation
      de sécurité, le Client devra en informer sans délai la Société afin que les mesures
      appropriées soient prises. La Société se réserve le droit de refuser ou suspendre l’ouverture
      d’un compte Client en cas de non-respect des CGU ou de fourniture d’informations
      d’enregistrement inexactes.
    </p>
  </section>

  <section id="offres">
    <h2>4. Description des offres et tarifs</h2>
    <p>
      Le Prestataire propose plusieurs formules d’abonnement au Service Qaryos, afin de s’adapter
      aux besoins des établissements professionnels (hôtels, campings, ERP, etc.). Chaque formule
      offre un niveau de service différent en termes de fonctionnalités et de services inclus, par
      exemple : nombre de sites gérés, nombre d’utilisateurs (administrateurs et rondiers)
      accessibles, fonctionnalités avancées de reporting ou d’alertes, support client standard ou
      premium, etc.
    </p>
    <p>
      Les tarifs correspondants à chaque formule d’abonnement sont indiqués en euros hors taxes (HT)
      sur le site web Qaryos (ou dans la proposition commerciale remise au Client le cas échéant).
      Le montant de la TVA applicable sera précisé lors de la facturation selon le taux en vigueur
      au moment de la commande. Sauf indication contraire, les prix s’entendent nets et hors frais
      éventuels (par exemple, frais d’installation ou de formation spécifiques) qui pourraient être
      facturés séparément après acceptation par le Client.
    </p>
    <p>
      La Société se réserve le droit de modifier son catalogue d’offres et sa grille tarifaire.
      Toute nouvelle offre ou tout nouveau tarif ne s’appliquera qu’aux nouvelles souscriptions ou
      aux renouvellements d’abonnement en cours, sous réserve d’en informer préalablement le Client
      dans un délai raisonnable. En cas de modification tarifaire affectant un abonnement en cours,
      le Client sera informé au moins 30 jours à l’avance. Le Client disposera de la possibilité de
      résilier son abonnement avant l’entrée en vigueur du nouveau tarif s’il ne souhaite pas
      l’accepter (voir article 7. Résiliation). À défaut de résiliation, le Client sera réputé avoir
      accepté le nouveau tarif pour la période suivante de son abonnement.
    </p>
  </section>

  <section id="paiement">
    <h2>5. Modalités de commande et de paiement</h2>
    <p>
      <b>5.1. Processus de commande :</b> Le Client peut souscrire un abonnement au Service Qaryos
      directement en ligne sur le site web. Il choisit la formule d’abonnement souhaitée, renseigne
      les informations demandées (identité de l’entreprise, coordonnées de facturation, etc.), et
      valide sa commande après avoir pris connaissance et accepté les présentes CGV et les CGU en
      cochant la case correspondante. Avant validation finale, le récapitulatif de commande (choix
      de l’offre, durée, prix total) est présenté au Client afin qu’il puisse corriger d’éventuelles
      erreurs. Le contrat est conclu une fois la commande confirmée par le Client (processus de «
      double-clic » ou validation équivalente) et confirmée par la Société par l’envoi d’un email de
      confirmation. La confirmation contient le détail de l’abonnement souscrit et une copie des CGV
      acceptées.
    </p>
    <p>
      <b>5.2. Facturation :</b> L’abonnement donne lieu à l’édition d’une facture par période (mois
      ou année, selon la formule). Chaque facture est émise soit immédiatement lors de la
      souscription (pour la première période d’abonnement), soit à chaque échéance périodique (pour
      les renouvellements). La facture est adressée au Client par voie électronique à l’adresse
      email de facturation fournie ou accessible depuis son espace client en ligne. Le Client
      accepte expressément l’usage de la facturation électronique.
    </p>
    <p>
      <b>5.3. Modalités de paiement :</b> Le paiement de l’abonnement s’effectue à l’avance pour
      chaque période d’abonnement. Les moyens de paiement acceptés sont indiqués lors de la commande
      (par exemple : carte bancaire via une plateforme de paiement sécurisée, prélèvement
      automatique SEPA, virement bancaire sur facture pro-forma, etc.). En cas de paiement par carte
      ou prélèvement, le Client autorise la Société à débiter automatiquement le moyen de paiement
      choisi à chaque échéance d’abonnement jusqu’à résiliation. En cas de paiement par virement ou
      mandat administratif (le cas échéant pour certains Clients publics ou grands comptes), le
      règlement devra intervenir sous X jours calendaires (par défaut 30 jours) à compter de la date
      d’émission de la facture.
    </p>
    <p>
      <b>5.4. Retard ou défaut de paiement :</b> En cas de retard de paiement total ou partiel d’une
      facture à son échéance, la Société se réserve le droit de suspendre l’accès au Service du
      Client, après en avoir notifié celui-ci. En outre, tout montant non payé à l’échéance prévue
      produira de plein droit et sans mise en demeure préalable des pénalités de retard.
      Conformément à l’article L.441-10 du Code de commerce, le taux d’intérêt des pénalités de
      retard ne peut être inférieur à trois (3) fois le taux d’intérêt légal en vigueur. Sauf
      disposition contraire, la Société appliquera un taux de pénalité de retard égal à 3 fois le
      taux d’intérêt légal, calculé par jour de retard. Ces pénalités courent à partir du jour
      suivant la date d’échéance de la facture jusqu’au paiement intégral.
    </p>
    <p>
      En outre, une indemnité forfaitaire pour frais de recouvrement d’un montant de 40 € sera due
      par le Client professionnel en retard de paiement, conformément aux articles L.441-10 et
      D.441-5 du Code de commerce. Si les frais de recouvrement exposés par la Société sont
      supérieurs à ce montant, la Société pourra demander une indemnisation complémentaire sur
      justification. Le Client ne pourra pas suspendre ou différer un paiement dû au motif d’une
      contestation relative au Service. En cas de difficultés financières du Client, la Société se
      tient à disposition pour rechercher une solution amiable de paiement échelonné, sans que cela
      ne vaille renonciation à ses droits.
    </p>
  </section>

  <section id="retractation">
    <h2>6. Droit de rétractation</h2>
    <p>
      Les services fournis par Qaryos s’adressent exclusivement à des professionnels dans le cadre
      de leur activité. Aucun droit de rétractation légal de 14 jours ne s’applique aux contrats
      d’abonnement conclus entre professionnels, conformément aux dispositions du Code de la
      consommation qui excluent le bénéfice du droit de rétractation pour les contrats B2B. Le
      Client reconnaît explicitement qu’il contracte en tant que professionnel et qu’à ce titre, il
      ne dispose d’aucune faculté de rétractation après la confirmation de sa commande.
    </p>
    <p>
      Par conséquent, toute commande d’abonnement passée par un Client est ferme et définitive dès
      son acceptation selon le processus décrit ci-dessus. Le Client ne pourra pas annuler la
      commande une fois confirmée, hors exercice éventuel de son droit de résiliation tel que prévu
      aux présentes CGV ou accord commercial particulier consenti par la Société à titre
      exceptionnel. Si, par erreur, un utilisateur non-professionnel souscrivait au Service, il lui
      appartiendrait de contacter sans délai la Société. Cette dernière se réserve la possibilité
      d’évaluer la situation au cas par cas, sans que cela ne crée d’obligation de sa part
      d’accorder un quelconque remboursement ou annulation hors cadre légal.
    </p>
  </section>

  <section id="resiliation">
    <h2>7. Résiliation de l’abonnement</h2>
    <p>
      <b>7.1. Résiliation à l’initiative du Client :</b> Le Client peut à tout moment décider de
      résilier son abonnement à Qaryos. La demande de résiliation peut être effectuée via
      l’interface du compte en ligne (section Abonnement/Facturation) ou par notification écrite
      adressée au support de la Société. La résiliation sera prise en compte pour la fin de la
      période d’abonnement en cours au moment de la demande. Par exemple, si l’abonnement est
      mensuel, l’accès au Service prendra fin à l’issue du mois déjà payé; si l’abonnement est
      annuel, il prendra fin à l’échéance de l’année d’abonnement en cours. Les sommes déjà versées
      restent acquises au Prestataire et ne seront pas remboursées au prorata de la période
      restante, sauf accord contraire exprès de la Société. Il appartient donc au Client d’anticiper
      sa demande de résiliation avant le renouvellement tacite de l’abonnement pour ne pas engager
      une période supplémentaire.
    </p>
    <p>
      <b>7.2. Résiliation à l’initiative de la Société :</b> Le Prestataire se réserve le droit de
      résilier tout contrat d’abonnement en cas de manquement grave du Client à ses obligations
      contractuelles. Sont notamment considérés comme des manquements graves : tout non-paiement
      persistant d’une facture malgré relance, tout non-respect des CGU du Service (ex: utilisation
      abusive ou illicite du Service), une atteinte aux droits de propriété intellectuelle de la
      Société, ou plus généralement toute violation des présentes CGV. Sauf urgence ou cas
      manifestement irrémédiable, la Société adressera au Client une mise en demeure par email ou
      courrier lui signalant le manquement et sollicitant sa correction dans un délai maximal de
      quinze (15) jours. Si à l’issue de ce délai le manquement n’est pas corrigé, la Société pourra
      notifier la résiliation immédiate de l’abonnement du Client, sans préjudice de tous
      dommages-intérêts auxquels elle pourrait prétendre du fait du manquement. En cas de manquement
      particulièrement grave (par exemple, usage du Service de manière volontairement illicite
      mettant en cause la sécurité du système ou des données), la résiliation pourra intervenir sans
      délai et sans mise en demeure préalable.
    </p>
    <p>
      <b>7.3. Conséquences de la fin du contrat :</b> En cas de résiliation ou de non-renouvellement
      de l’abonnement, l’accès du Client au Service sera désactivé à la date effective de fin de
      contrat. Il est vivement conseillé au Client d’exporter les données qu’il souhaite conserver
      avant cette date. La Société pourra supprimer ou rendre inaccessibles les données du Client
      stockées sur le Service au-delà d’un certain délai (par exemple 30 jours) suivant la fin du
      contrat, sauf obligation légale de conservation contraire. La résiliation du contrat, quelle
      qu’en soit la cause, ne porte pas atteinte aux clauses qui, par leur nature, doivent survivre
      (telles que les clauses de limitation de responsabilité, propriété intellectuelle,
      confidentialité, etc., qui continueront à produire leurs effets). La résiliation n’affecte pas
      non plus le droit de la Société de réclamer toute somme échue au moment de la fin du contrat
      ou indemnisation pour tout préjudice subi du fait des manquements du Client.
    </p>
  </section>

  <section id="responsabilite">
    <h2>8. Responsabilité et garanties</h2>
    <p>
      <b>8.1. Responsabilité du Prestataire :</b> La Société s’engage à apporter tout le soin et la
      diligence nécessaires à la fourniture d’un Service conforme aux spécifications de ses offres.
      Il s’agit d’une obligation de moyens. Le Client reconnaît que, malgré les efforts du
      Prestataire, le Service Qaryos, comme tout logiciel SaaS, peut comporter ponctuellement des
      anomalies ou interruptions indépendantes de la volonté de la Société (maintenance, mises à
      jour, pannes techniques, etc.). La Société ne garantit pas une disponibilité ininterrompue du
      Service ni l’absence totale d’erreurs. Cependant, en cas d’incident majeur affectant le
      Service, la Société s’efforcera d’informer le Client dans les meilleurs délais et de mettre en
      œuvre les moyens raisonnables pour rétablir la situation. La responsabilité de la Société ne
      pourra être engagée qu’en cas de faute prouvée de sa part et sera strictement limitée aux
      dommages directs subis par le Client résultant du manquement du Prestataire. En aucun cas la
      Société ne saurait être tenue responsable des dommages indirects ou imprévisibles du Client ou
      de tiers, tels que la perte de chiffre d’affaires, de clients, de données, un manque à gagner,
      un préjudice d’image ou toute autre conséquence financière. Dans tous les cas, dans la mesure
      permise par la loi, la responsabilité globale de la Société, si elle venait à être retenue,
      serait limitée au montant total des sommes effectivement versées par le Client au titre de
      l’abonnement durant les douze (12) derniers mois précédant le fait générateur du dommage.
      Cette limitation s’applique que la responsabilité soit contractuelle, délictuelle, ou autre,
      et quel que soit le nombre de faits dommageables. Aucune clause des présentes CGV n’a pour
      objet d’exclure ou de limiter la responsabilité du Prestataire en cas de dommages corporels ou
      de faute lourde/dolosive avérée, dans la mesure où une telle exclusion ou limitation serait
      interdite par la loi.
    </p>
    <p>
      <b>8.2. Responsabilité du Client :</b> Le Client est seul responsable de l’utilisation qu’il
      fait du Service Qaryos, ainsi que des données qu’il renseigne ou des instructions qu’il donne
      via le Service. Il lui appartient de vérifier l’adéquation du Service à ses besoins
      spécifiques, d’utiliser le Service conformément à sa documentation et aux bonnes pratiques
      communiquées, et de former ses utilisateurs (agents de sécurité, etc.) à son utilisation. Le
      Client est également responsable de la sécurité de ses systèmes d’information et de son réseau
      lors de l’accès au Service (par exemple, maintenir à jour ses équipements et logiciels,
      protéger ses identifiants d’accès, etc.). La Société ne saurait être tenue responsable en cas
      de manquement du Client à ses propres obligations, y compris en cas d’utilisation du Service
      non conforme aux instructions ou finalités prévues, ou en cas d’utilisation par un personnel
      non autorisé. Le Client garantit la Société contre toute revendication ou action de tiers
      fondée sur des informations ou données fournies par le Client via le Service, ou sur une
      utilisation du Service par le Client en violation des lois et règlements en vigueur.
    </p>
    <p>
      <b>8.3. Assurance :</b> Chaque Partie déclare être assurée auprès d’une compagnie d’assurance
      notoirement solvable pour les conséquences pécuniaires de sa responsabilité civile
      professionnelle pouvant découler du présent contrat. Le Prestataire s’engage à maintenir une
      assurance couvrant sa responsabilité d’éditeur de logiciel et de prestataire de services en
      ligne pendant toute la durée du contrat.
    </p>
  </section>

  <section id="force-majeure">
    <h2>9. Cas de force majeure</h2>
    <p>
      Aucune des Parties ne pourra être tenue pour responsable vis-à-vis de l’autre en cas de
      non-exécution ou de retard dans l’exécution de l’une de ses obligations contractuelles, qui
      serait dû à un cas de force majeure. Constituent notamment des cas de force majeure, en plus
      de ceux habituellement reconnus par la jurisprudence française : les catastrophes naturelles
      (tempêtes, inondations, tremblements de terre…), les incendies, les pandémies, les conflits
      armés ou attentats, les conflits du travail externes (grèves générales, lock-out ou grèves des
      services essentiels), les actes des autorités publiques, les défaillances généralisées du
      réseau Internet ou des infrastructures de télécommunications, ou tout autre événement
      échappant raisonnablement au contrôle de la Partie concernée.
    </p>
    <p>
      En cas de survenance d’un cas de force majeure, la Partie empêchée notifiera l’autre Partie de
      la situation dans les meilleurs délais, en précisant la nature de l’événement de force majeure
      et, si possible, son évaluation de la durée et des conséquences prévisibles. Les obligations
      affectées par l’événement de force majeure seront suspendues pendant toute la durée de
      celui-ci. Si l’empêchement est temporaire, l’exécution du contrat reprend dès que la cause de
      force majeure cesse, le calendrier contractuel étant ajusté si nécessaire. Si l’événement de
      force majeure se prolonge au-delà d’une durée de deux (2) mois consécutifs, chacune des
      Parties aura la faculté de résilier de plein droit le contrat par notification écrite à
      l’autre Partie, sans indemnité. La résiliation prendra effet quinze (15) jours après la date
      d’envoi de cette notification, sauf accord contraire entre les Parties. Les prestations déjà
      fournies et consommées jusqu’à cette date resteront dues. Aucune des Parties ne pourra
      réclamer de dommages-intérêts pour les suspensions ou la résiliation résultant d’un cas de
      force majeure, l’exécution du contrat étant simplement suspendue ou terminée sans faute des
      Parties dans ce cas.
    </p>
  </section>

  <section id="propriete">
    <h2>10. Propriété intellectuelle</h2>
    <p>
      <b>10.1. Droits du Prestataire sur le Service :</b> Le Service Qaryos, y compris l’ensemble de
      ses composantes (notamment le logiciel, les applications web et mobile, les bases de données,
      l’interface utilisateur, les graphismes, le logo, la marque Qaryos et tout contenu textuel ou
      média fourni par la Société) est la propriété exclusive de la Société ou de ses concédants.
      Ces éléments sont protégés par le droit d’auteur, le droit des marques, le droit des bases de
      données et/ou d’autres droits de propriété intellectuelle en vigueur. La souscription d’un
      abonnement n’opère aucun transfert de propriété intellectuelle au bénéfice du Client. La
      Société concède au Client un droit d’utilisation personnel, non-exclusif, non cessible et
      limité au périmètre de l’abonnement souscrit (nombre d’utilisateurs autorisés, fonctionnalités
      choisies, durée du contrat, etc.), et ce pour le monde entier (sauf restrictions géographiques
      précisées dans l’offre) et pour la durée du contrat. Ce droit d’utilisation est strictement
      destiné à permettre au Client d’utiliser le Service conformément à sa destination, pour ses
      besoins professionnels internes. Le Client s’interdit, directement ou indirectement, de porter
      atteinte aux droits de la Société sur le Service et ses éléments. Il s’engage notamment à ne
      pas reproduire, représenter, modifier, adapter, traduire, extraire, désassembler, procéder à
      de l’ingénierie inverse ou tenter de dériver le code source du Service ou de l’une de ses
      parties, ni chercher à créer des œuvres dérivées à partir du Service, sauf autorisation écrite
      préalable de la Société ou cas autorisés par la loi. De même, le Client s’abstiendra de
      retirer ou masquer les mentions de propriété (marques, copyright) apposées sur l’interface ou
      la documentation du Service.
    </p>
    <p>
      <b>10.2. Données du Client :</b> Les données que le Client héberge, saisit ou génère via le
      Service (par exemple : données relatives aux sites surveillés, plans de rondes, rapports
      d’incident, logs d’activité, etc.) restent en pleine propriété du Client. Le Prestataire
      n’acquiert aucun droit de propriété sur ces données. Le Client accorde toutefois à la Société,
      pendant la durée du contrat, une licence d’utilisation de ces données strictement limitée aux
      besoins de l’exécution du Service (y compris à des fins de sauvegarde, de sécurité, de support
      technique, ou d’amélioration des fonctionnalités de la plateforme). La Société s’engage à
      garder confidentielles les données du Client et à ne pas les utiliser à d’autres fins ni les
      divulguer à des tiers non autorisés, conformément aux engagements de la Politique de
      confidentialité et, le cas échéant, au contrat de traitement des données personnelles (si RGPD
      applicable).
    </p>
    <p>
      <b>10.3. Contenus tiers :</b> Certains éléments intégrés au Service pourraient être concédés
      sous licence par des tiers (par exemple, bibliothèques logicielles open-source, API de
      cartographie pour visualiser les rondes, etc.). La Société déclare disposer des droits ou
      licences nécessaires à leur utilisation dans le cadre du Service. Le Client s’engage de son
      côté à respecter, le cas échéant, les conditions d’utilisation de ces contenus tiers dont il
      serait expressément informé.
    </p>
  </section>

  <section id="droit">
    <h2>11. Droit applicable et juridiction</h2>
    <p>
      Les présentes CGV, ainsi que l’ensemble des contrats d’abonnement conclus avec la Société,
      sont soumises au droit français. Il en est ainsi pour les règles de fond comme pour les règles
      de forme, et ce nonobstant le lieu d’exécution des prestations ou la nationalité du Client. De
      plus, la langue d’interprétation des présentes CGV est la langue française. Toute version
      traduite éventuelle ne serait fournie qu’à titre informatif.
    </p>
    <p>
      En cas de différend relatif à l’interprétation, l’exécution ou la cessation du contrat
      d’abonnement, les Parties s’efforceront de régler amiablement leur litige. À défaut d’accord
      amiable dans un délai raisonnable, tous les litiges auxquels le présent contrat pourrait
      donner lieu (validité, interprétation, exécution, résiliation, etc.) seront soumis à la
      compétence exclusive des tribunaux matériellement compétents du ressort du siège social de la
      Société, sauf disposition légale impérative contraire. Cette attribution de compétence est
      acceptée par le Client sans réserve, y compris pour les procédures d’urgence ou les procédures
      conservatoires, en référé ou par requête.
    </p>
    <p>
      Le Client reconnaît avoir lu et compris l’intégralité des présentes Conditions Générales de
      Vente et déclare les accepter sans réserve. Il est conseillé de conserver une copie de ce
      document pour ses archives.
    </p>
  </section>
</div>
